export const USER_ACTION_DIALOG_TYPE = {
    Message: "message",
    Error: "error"
};
